import React, {
    Component,
    PropTypes
} from 'react';
import moment from "moment";
import {
    Link
} from "react-router";
import {getUserId} from 'UTIL/common'
import userService from 'SERVICES/ella/userService'
var ReactBsTable = require('react-bootstrap-table');
var BootstrapTable = ReactBsTable.BootstrapTable;
var TableHeaderColumn = ReactBsTable.TableHeaderColumn;
const userType = {
    3:"普通用户",
    2:"管理员",
}
import ellaService from 'SERVICES/purifier/ella/ellaService'
import Tip from 'COMPONENT/tip'
import {language,pageOption} from 'UTIL/common'
import Modal from 'COMPONENT/modal'
import LongSearchInput from 'CONFIG/component/search/longSearchInput'
import {timesTampsToData} from 'CONFIG/function'
import SearchSelect from '../../../component/search/searchSelect';


function enumFormatter(cell, row, enumObject) {
    return enumObject[row.userTypeId];
}
const returnMsg=(body)=>{
    if (body.code == 8001) {
        $("#success_msg").text(body.msg);
        $("#success_tip").removeClass("hidden");
        $("#success_tip").focus();
        setTimeout(function() {
            $("#success_tip").addClass("hidden");
        }, 3000);
    } else {
        $("#error_msg").text(body.msg);
        $("#error_tip").removeClass("hidden");
        $("#error_tip").focus();
        setTimeout(function() {
            $("#error_tip").addClass("hidden");
        }, 3000);
    }
}
export default class NormalUser extends Component {
    constructor(props) {
        super(props);
        this.delList = this.delList;
        // this.delClick = this.delClick;
        this.handle = this.handle.bind(this);
        this.search = this.search.bind(this);
        this.appType = this.appType.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
        this.state = {
            list: [],
            size: 10,
            current: 1,
            total: 0,
            delRow: {id:"",name:""},
            disableId : '',
            enableId : '',
            appTypeList:{}
        };
    }
    componentDidMount() {
        this.onPageChange(this.state.current,this.state.size);
    }

    delList(id, name) {
        var delRow = {
            id:id,
            name:name,
        };
        this.setState({
            delRow:delRow
        });
        console.log(delRow);
    };

    handle(cell, row) {
        //0 启用 1 禁用
        var div = row.state == 0?<a className="btn btn-sm btn-danger" data-target="#disable" data-toggle="modal"
                                    onClick={this.disableClick.bind(this,row.id,row.roleName)}>{language()['disable']}</a>:
            <a className="btn btn-sm btn-dropbox" data-target="#enable" data-toggle="modal"
               onClick={this.enableClick.bind(this,row.id,row.roleName)}>{language()['enable']}</a>;

        return <div>
            {/*{div}&nbsp;&nbsp;*/}
            {/*<Link  to = {"/ella/user/user/normalEdit/"+row.id} className="btn btn-sm btn-info">*/}
                {/*{language()['edit']}*/}
            {/*</Link>&nbsp;&nbsp;*/}
            {/*<a className="btn btn-md btn-danger" data-target="#tipModal" data-toggle="modal"*/}
            {/*onClick={this.delList.bind(this,row.id,row.roleName)}>删除</a>&nbsp;&nbsp;*/}
            <Link  to = {"/ella/user/user/normalUserDetail/"+row.id} className="btn btn-warning btn-sm">
                {language()['view']}
            </Link>
        </div>

    };
    appType(cell, row) {
        return this.state.appTypeList[row.appType];
    }
    disableClick(id){
        this.setState({
            disableId : id,
        })
    }
    enableClick(id){
        this.setState({
            enableId : id,
        })
    }
    onPageChange(page, sizePerPage, e) {
        const json = {
            current:page,
            size:sizePerPage,
            search:$("#name").val(),
            appType:$("#appType").val(),
            userId:getUserId(),
            userTypeId:3,
        };
        const data = JSON.stringify(json);
        userService.getUserList({data}).then(body=>{
            console.log(body)
            if(body.data !=null) {
                this.setState({
                    current: page,
                    size: sizePerPage,
                    list: body.data.list.records,
                    total: body.data.list.total,
                    appTypeList: body.data.EnumApp
                })
            }
        })
    }
    search() {
        this.onPageChange(this.state.current,this.state.size);
    }
    


    dateFormate(cell,row){
        return row.regTime == null?"":timesTampsToData(row.regTime);
    }
    disable(){
        var id = this.state.disableId;
        ellaService.disableUser(id).then(body=>{
            this.onPageChange(this.state.current,this.state.size);
            returnMsg(body)
        })
    }
    enable(){
        var id = this.state.enableId;
        ellaService.enableUser(id).then(body=>{
            this.onPageChange(this.state.current,this.state.size);
            returnMsg(body)
        })
    }
    reset(){
        $("#name").val('');
        $("#appType").val('');
        this.onPageChange(1,10)
    }

    render() {
        let options = pageOption(this.state.current,this.state.size);
        options['onPageChange'] = this.onPageChange.bind(this);
        const _this = this;
        options['paginationShowsTotal'] =function () {
            return <span style={{paddingRight:'10px'}}>
                共 <span className="bg-blue" style={{fontSize:'20px',padding:'2px 4px',borderRadius:'5px'}}>{_this.state.total}</span> 条数据
            </span>
        };
        return (
            <div >
                <section className="content-header " >
                    <h1> {language()['userManage']} <small>{language()['normalUserList']}</small> </h1>
                </section>
                <section className="content" >
                    <div className="box box-primary color-palette-box">
                        <div className="box-header with-border">
                            <i className="fa fa-list"></i>
                            <h3 className="box-title">{language()['normalUserList']}</h3>
                            {/*<div style={{marginRight:"10px",float:"right"}}>*/}
                                {/*<Link  to = "/ella/user/user/normalAdd" className="btn btn-success btn-md"  >*/}
                                    {/*<i className="fa fa-plus-circle"></i> {language()['add']}*/}
                                {/*</Link>*/}
                            {/*</div>*/}
                        </div>
                        <div className="box-body">
                            <Tip ids=""/>
                            <div className="title-box">
                                <div className="clearfix">
                                    <LongSearchInput id="name" name={language()['loginName']}/>
                                    <SearchSelect id="appType" name="APP类型" data={this.state.appTypeList} />
                                    <button type="button" className="btn btn-info" onClick={this.search.bind(this)}>
                                        {language()['query']}
                                        </button>&nbsp;&nbsp;
                                    <button type="button" className="btn btn-warning" id="reset" onClick={this.reset.bind(this)}>
                                        {language()['resetting']}
                                        </button>
                                </div>
                            </div>
                            <div >
                                <BootstrapTable data = {this.state.list}  remote={true} fetchInfo={{ dataTotalSize: this.state.total }} striped hover pagination={true} options={options} ref='table' height={'auto'} >
                                    <TableHeaderColumn isKey dataField='id'hidden="true">ID</TableHeaderColumn>
                                    <TableHeaderColumn  dataField='userNo' width="120">用户编号</TableHeaderColumn>
                                    <TableHeaderColumn dataField='loginName'  width="200">{language()['loginName']}</TableHeaderColumn>
                                    <TableHeaderColumn  dataFormat={this.appType}  width="120">{language()['appType']}</TableHeaderColumn>
                                    <TableHeaderColumn  dataField='regTime'  dataFormat={this.dateFormate} width="120">{language()['registerTime']}</TableHeaderColumn>
                                    <TableHeaderColumn  dataField='address'  width="220">{language()['address']}</TableHeaderColumn>
                                    <TableHeaderColumn  dataFormat={this.handle} width="120"  columnClassName="td-mid">{language()['operation']}</TableHeaderColumn>
                                </BootstrapTable>
                            </div>
                        </div>
                    </div>
                </section>
                {/*<ModalDel id="tipModal" delModSure = {this.delClick.bind(this,this.state.delRow.id)}/>*/}
                <Modal modal={{"id":'enable',"title":'enable',"text":'readyEnable'}}  modalSure= {this.enable.bind(this)}/>
                <Modal modal={{"id":'disable',"title":'disable',"text":'readyDisable'}}  modalSure= {this.disable.bind(this)}/>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./modules/ella/user/user/normalUser.js